import { z } from "zod";

export type Nilable<S extends z.ZodType> = z.ZodOptional<z.ZodNullable<S>>;

// TODO: zod-utils
export function nilable<S extends z.ZodType>(schema: S) {
  return z.optional(z.nullable(schema));
}
